<script>
import { mapState } from 'vuex';

export default {
    name: "menus",
    data() {
        return {
            desc: ''
        };
    },
    computed: {
        ...mapState(['studyMenu']),
    },
    components: {
        
    },
    mounted() {
        this.$store.dispatch('getStudyMenu');
    },
    destroyed() {},
    watch: {
        'studyMenu': {
            handler: function (value) { 
                if (value.length > 0) { 
                    this.getDesc();
                }
            },
            immediate: true
        },
        '$route': 'getDesc'
    },
    methods: {
        getDesc() { 
            if (this.$route.path == '/study') { 
                this.desc = this.studyMenu[0].desc;
            } else {
                for (let i = 0; i < this.studyMenu[0].children.length; i++) {
                    const item = this.studyMenu[0].children[i];
                    if (this.$route.query.id == item.id) { 
                        this.desc = item.desc;
                        break;
                    }
                }
            }
        }
    },
};
</script>

<template>
    <div class="menus layout_body" v-if="studyMenu.length > 0">
        <!-- banner -->
        <div class="banner">
            <div class="layout_bg bg" :style="`background-image: url(${studyMenu[0].image});`"></div>
        </div>
        <div class="layout_main">
            <div class="layout_content wrapper">
                <div class="menu flex">
                    <!-- 总目录 -->
                    <router-link class="item" to="/study">{{ studyMenu[0].name }}</router-link>
                    <!-- 子目录 -->
                    <router-link class="item" v-for="(item, index) in studyMenu[0].children" :key="index" :to="`/study/list?id=${item.id}`">{{ item.name }}</router-link>
                </div>
                <!-- <div class="menu flex">
                    <router-link class="item" v-for="(item, index) in menu" :key="index" :to="item.link">{{ item.name }}</router-link>
                </div> -->
                <p class="desc" v-if="desc">{{ desc }}</p>
                <!--  -->
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    width: 100%;
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 6.3rem;
    }
}
.wrapper{
    @media only screen and (max-width: 750px) {
        padding: 0 0 .3rem;
    }
}
.menu{
    gap: .3rem;
    z-index: 2;
    margin-bottom: .3rem;
    .item{
        font-size: .2rem;
        color: #999;
        cursor: pointer;
        border-bottom: 1px solid transparent;
        &:hover,
        &.exact-active{
            color: var(--font_color);
            border-color: var(--font_color);
        }
    }
    @media only screen and (max-width: 750px) {
        width: 7.5rem;
        margin: 0 -.3rem;
        padding: 0;
        top: 1.6rem;
        padding: 0 .3rem;
        overflow: hidden;
        overflow-x: scroll;
        gap: .8rem;
        border-bottom: 1px solid #999;
        margin-bottom: .3rem;
        .item{
            line-height: .9rem;
            font-size: .25rem;
            white-space: nowrap;
            border-bottom: none;
        }
    }
}
.desc{
    font-size: .22rem;
    margin-bottom: .6rem;
    @media only screen and (max-width: 750px) {
        font-size: .26rem;
        margin-bottom: .3rem;
    }
}
</style>